import axios from 'axios';
import {
  CREATE_FORM_STATUS_URL,
  EDIT_FORM_STATUS_URL,
  GET_ALL_FORM_STATUSES_URL,
  GET_ALL_FORM_TYPES_URL,
  GET_ALL_QUESTION_TYPES_URL,
  get_request_config,
} from '@/utils/system_constants/constant.js';


// Foundation
function parse_json_string(value, fallback = {}) {
  try { return JSON.parse(value); }
  catch { return fallback; }
}

function parse_response_data(response) {
  const raw_data = response?.data ?? response ?? {};

  if (typeof raw_data !== 'string') {
    return raw_data;
  }

  const parsed_data = parse_json_string(raw_data);

  return typeof parsed_data === 'string' ? parse_json_string(parsed_data) : parsed_data;
}

function extract_items(response) {
  const parsed = parse_response_data(response);
  const items = parsed?.data ?? parsed?.results ?? [];

  return Array.isArray(items) ? items : [];
}

export const fetch_question_types = async () => {
  const request_config = get_request_config();
  const response = await axios.get(GET_ALL_QUESTION_TYPES_URL, request_config);

  return extract_items(response);
};

export const fetch_form_types = async () => {
  const request_config = get_request_config();
  const response = await axios.get(GET_ALL_FORM_TYPES_URL, request_config);

  return extract_items(response);
};

export const fetch_form_statuses = async () => {
  const request_config = get_request_config();
  const response = await axios.get(GET_ALL_FORM_STATUSES_URL, request_config);

  return extract_items(response);
};

export const create_form_status = async (payload = {}) => {
  const request_config = get_request_config();
  const response = await axios.post(CREATE_FORM_STATUS_URL, payload, request_config);

  return parse_response_data(response);
};

export const edit_form_status = async (payload = {}) => {
  const request_config = get_request_config();
  const response = await axios.post(EDIT_FORM_STATUS_URL, payload, request_config);

  return parse_response_data(response);
};

export const fetch_form_metadata = async () =>
  Promise.allSettled([
    fetch_question_types(),
    fetch_form_types(),
    fetch_form_statuses(),
  ]).then(([question_types_result, form_types_result, form_statuses_result]) => ({
    question_types: question_types_result.status === 'fulfilled' ? question_types_result.value : [],
    form_types: form_types_result.status === 'fulfilled' ? form_types_result.value : [],
    form_statuses: form_statuses_result.status === 'fulfilled' ? form_statuses_result.value : [],
  }));
